import { render, staticRenderFns } from "./main_star_assignment_component.vue?vue&type=template&id=24a3a8fa&scoped=true"
import script from "./main_star_assignment_component.vue?vue&type=script&lang=js"
export * from "./main_star_assignment_component.vue?vue&type=script&lang=js"
import style0 from "./main_star_assignment_component.vue?vue&type=style&index=0&id=24a3a8fa&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a3a8fa",
  null
  
)

export default component.exports